import React from "react"
import { Button } from "antd"
import { CopyOutlined } from "@ant-design/icons"

import { notify } from "../notify"
import css from "./index.module.css"

type Props = {
  content: string
  message?: string
  style?: React.CSSProperties
  view?: React.ReactElement
}
export const CopyBlock = ({ content, message, style, view }: Props) => {
  const handleClick = (): void => {
    navigator.clipboard.writeText(content)

    notify.success(message)
  }

  return (
    <div className={css.container} style={style}>
      <span>{view ?? content}</span>
      <Button
        className={css.button}
        icon={<CopyOutlined />}
        id="GENERATED_ID_COPYBLOCK_BUTTON_VOID_1"
        onClick={handleClick}
        size="large"
        type="primary"
      ></Button>
    </div>
  )
}
